import { CatalogNode } from '@catalog/const/v2';
import { StateUtils } from '@spartacus/core';

export const CATALOG_FEATURE = 'catalog feature';
export const CATALOG = '[Catalog Layout] Catalog';
export const CATALOG_ROOT_NODE_ID = '[Catalog Layout] Catalog Root Node Id';

export interface CatalogData {
  nodes: {
    [nodeId: string]: CatalogNode;
  };
}

export interface StateWithCatalog {
  [CATALOG_FEATURE]: CatalogState;
}

export interface CatalogState {
  catalog: StateUtils.LoaderState<CatalogData>;
  rootNodeId: StateUtils.LoaderState<string>;
}
